import { render, staticRenderFns } from "./assetDetail.vue?vue&type=template&id=42e7252c&scoped=true&"
import script from "./assetDetail.vue?vue&type=script&lang=js&"
export * from "./assetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e7252c",
  null
  
)

export default component.exports